export const BELONGS_META = {
    gameroom: { key: 'gameroom', icon: '🎰', label: 'Game Rooms' },
    business: { key: 'business', icon: '💼', label: 'Businesses' },
    personal: { key: 'personal', icon: '👤', label: 'Personal' },
    property: { key: 'property', icon: '🏠', label: 'Property Management' },
};

export const BELONGS_KEYS = ['gameroom', 'business', 'personal', 'property'];
